import {useCallback, useEffect, useRef} from 'react';

/**
 * Returns a function that returns true if the component is mounted, false otherwise.
 * @deprecated migrate to ui
 */
export function useIsMount(): () => boolean {
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const isMounted = useCallback(() => isMountedRef.current, []);

  return isMounted;
}
